import React from 'react';
import './TeamCapability.css';
import { Bar, Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
);

const TeamCapability = ({ employees }) => {
  // 提取所有技能并统计频率
  const skillsFrequency = employees.reduce((acc, emp) => {
    if (emp.skills) {
      const skills = emp.skills.split(',').map(s => s.trim());
      skills.forEach(skill => {
        acc[skill] = (acc[skill] || 0) + 1;
      });
    }
    return acc;
  }, {});

  // 按频率排序并获取前10个技能
  const topSkills = Object.entries(skillsFrequency)
    .sort(([, a], [, b]) => b - a)
    .slice(0, 10);

  // 柱状图数据
  const barData = {
    labels: topSkills.map(([skill]) => skill),
    datasets: [
      {
        label: '掌握人数',
        data: topSkills.map(([, count]) => count),
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      }
    ]
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: '团队技能分布'
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1
        }
      }
    }
  };

  // 计算每个类别的平均IDP完成度
  const categoryProgress = employees.reduce((acc, emp) => {
    if (emp.category && emp.idpProgress) {
      if (!acc[emp.category]) {
        acc[emp.category] = { total: 0, count: 0 };
      }
      // 简单计算进度：有进展记录就算50%，否则0%
      const progress = emp.idpProgress.trim() ? 50 : 0;
      acc[emp.category].total += progress;
      acc[emp.category].count += 1;
    }
    return acc;
  }, {});

  // 雷达图数据
  const radarData = {
    labels: Object.keys(categoryProgress),
    datasets: [
      {
        label: 'IDP完成度',
        data: Object.values(categoryProgress).map(({ total, count }) => 
          count > 0 ? Math.round(total / count) : 0
        ),
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      }
    ]
  };

  const radarOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: '各类别IDP完成度'
      }
    },
    scales: {
      r: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 20
        }
      }
    }
  };

  return (
    <div className="team-capability">
      <div className="capability-header">
        <h2>团队能力分析</h2>
        <div className="summary-stats">
          <div className="stat-item">
            <div className="stat-value">{Object.keys(skillsFrequency).length}</div>
            <div className="stat-label">技能总数</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">
              {Math.round(Object.values(skillsFrequency).reduce((a, b) => a + b, 0) / employees.length)}
            </div>
            <div className="stat-label">人均技能数</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">
              {employees.filter(emp => emp.idpGoals && emp.idpGoals.trim()).length}
            </div>
            <div className="stat-label">有IDP目标人数</div>
          </div>
        </div>
      </div>

      <div className="charts-container">
        <div className="chart-section">
          <h3>技能分布</h3>
          <div className="bar-chart">
            <Bar data={barData} options={barOptions} />
          </div>
        </div>
        <div className="chart-section">
          <h3>IDP完成度</h3>
          <div className="radar-chart">
            <Radar data={radarData} options={radarOptions} />
          </div>
        </div>
      </div>

      <div className="skills-table">
        <h3>技能详情</h3>
        <table>
          <thead>
            <tr>
              <th>技能</th>
              <th>掌握人数</th>
              <th>占比</th>
            </tr>
          </thead>
          <tbody>
            {topSkills.map(([skill, count]) => (
              <tr key={skill}>
                <td>{skill}</td>
                <td>{count}</td>
                <td>{((count / employees.length) * 100).toFixed(1)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TeamCapability; 